import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useDialog } from '../components/Modal/DialogContext';
import { useNavigate } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const ResetPassword: React.FC = () => {
  const { user, resetPassword } = useAuth();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showConfirmError, setShowConfirmError] = useState(false);

  
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const dialog = useDialog();
  const navigate = useNavigate();


  if (user) return <Navigate to="/" />; // ✅ Weiterleiten wenn eingeloggt

  const passwordRules = [
    {
      label: "Großbuchstaben",
      isValid: /[A-Z]/.test(password),
    },
    {
      label: "Kleinbuchstaben",
      isValid: /[a-z]/.test(password),
    },
    {
      label: "Zahlen",
      isValid: /[0-9]/.test(password),
    },
    {
      label: " Sonderzeichen  (e.g., !, @, #, $, %, ^, *, &)",
      isValid: /[!@#$%^*&,]/.test(password),
    },
    {
      label: " Mindestens 6 Zeichen",
      isValid: password.length >= 6,
    },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setShowConfirmError(false);
    setLoading(true);
    setError(null);
    if  (password !== confirmPassword){
      setShowConfirmError(true);
      setLoading(false);
      return;
    }

    

    try {
      if (!token) {
        setError("Kein Token in der URL gefunden.");
        setLoading(false);
        return;
      }
      await resetPassword(token, password);

      dialog({
        type: 'alert',
        title: 'Passwort zurückgesetzt',
        message: 'Das Passwort wurde erfolrgreich zurückgesetzt. Sie werden nun zum Login weitergeleitet.',
        confirmButton: 'OK',
        onConfirm: () => navigate("/login"),

      });
      

    } catch (err) {
      dialog({
        type: 'alert',
        title: 'Fehlgeschlagen',
        message: 'Das Zurücksetzen des Passworts ist fehlgeschlagen. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Support',
        confirmButton: 'OK',

      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="tw-h-full tw-overflow-auto tw-px-5 sm:tw-px-0">
      <div className="sm:tw-max-w-[90%] tw-w-full tw-mx-auto tw-h-full">
        <div className="tw-flex tw-flex-col tw-h-full">
          <nav className="tw-flex tw-justify-center tw-sticky tw-top-0 tw-py-5 tw-bg-white tw-z-10">
            <div className="mt-4">
              <a href="">
                <img
                  src="/kvita-logo.png"
                  alt="logo"
                  className="block w-[260px] h-auto"
                />
              </a>
            </div>
          </nav>

          <main className="tw-flex-1 tw-grid md:tw-items-center">
            <div className="tw-max-w-[400px] tw-w-full tw-flex tw-items-center tw-py-6 tw-mx-auto tw-relative">
              <div className="tw-w-full">
                <h3 className="tw-text-center tw-mb-8 ">Neues Passwort erstellen</h3>
                <form data-gtm-form-interact-id="0">
                  <div className="tw-grid tw-gap-4 tw-mb-6">
                    <div className="tw-grid tw-gap-2">
                      <div className="auth-input-field">
                        <label className="tw-text-gray-black tw-inline-block tw-mb-2 tw-text-xs">Neues Passwort</label>
                        <div className="input__container__div ad-input__container !tw-text-sm">

                          <input
                            required
                            type={showPassword ? "text" : "password"}
                            autoComplete="new-password"
                            className="tw-border tw-p-2 tw-font-normal tw-text-sm tw-border-solid tw-border-black tw-text-gray-black tw-rounded-lg tw-w-full tw-block tw-outline-none tw-border-gray-100 focus:tw-border-primary-500 hover:tw-border-[#C2C2C2] tw-pr-6"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          /><div className="input__container__div__input__icon" onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer", position: "relative", top: "-5px" }}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </div>
                          <div>
                            <button type="button" className="tw-absolute tw-right-0 tw-px-2 tw-top-0 tw-bottom-0 tw-grid tw-place-items-center tw-text-gray-500 tw-text-lg tw-cursor-pointer">
                              {/* SVG icon */}
                            </button>
                          </div>
                        </div>
                      </div>

                      <ul className="tw-ml-0 tw-grid tw-gap-2 tw-pl-0  tw-text-sm">

                        {passwordRules.map((rule, i) => (
                          <li
                            key={i}
                            className={`tw-flex tw-items-center tw-gap-x-3 tw-ml-0 tw-mt-1 ${rule.isValid ? 'tw-text-success-500' : 'tw-text-gray-400'
                              } shadow-none hover:shadow-none bg-transparent hover:bg-transparent`}
                          >
                            <div className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
                              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M8.00004 15.1663C11.6667 15.1663 14.6667 12.1663 14.6667 8.49967C14.6667 4.83301 11.6667 1.83301 8.00004 1.83301C4.33337 1.83301 1.33337 4.83301 1.33337 8.49967C1.33337 12.1663 4.33337 15.1663 8.00004 15.1663Z"
                                  stroke={rule.isValid ? "#20A961" : "#9CA3AF"}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M5.16663 8.49995L7.05329 10.3866L10.8333 6.61328"
                                  stroke={rule.isValid ? "#20A961" : "#9CA3AF"}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <p className="tw-m-0 tw-text-xs">{rule.label}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <div className="auth-input-field">
                        <label className="tw-text-gray-black tw-inline-block tw-mb-2 tw-text-xs">Neues Passwort bestätigen</label>
                        <div className="input__container__div ad-input__container !tw-text-sm">
                          <input
                            required
                            type={showConfirmPassword ? "text" : "password"}
                            className="tw-border tw-p-2 tw-font-normal tw-text-sm tw-border-solid tw-border-black tw-text-gray-black tw-rounded-lg tw-w-full tw-block tw-outline-none tw-border-gray-100 focus:tw-border-primary-500 hover:tw-border-[#C2C2C2] tw-pr-6"
                            value={confirmPassword}
                            autoComplete="new-password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          /><div className="input__container__div__input__icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ cursor: "pointer", position: "relative", top: "-5px" }}>
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </div>
                          <div>
                            
                            <button type="button" className="tw-absolute tw-right-0 tw-px-2 tw-top-0 tw-bottom-0 tw-grid tw-place-items-center tw-text-gray-500 tw-text-lg tw-cursor-pointer">
                              {/* SVG icon */}
                            </button>
                          </div>
                          
                        </div>{showConfirmError && (
                                                <p className="input__container__div__error !tw-text-xs">
                                                    Die Passwöter stimmen nicht überein!
                                                </p>
                                            )}
                      </div>
                    </div>
                  </div>
                  <div className=" tw-absolute tw-bottom-0 tw-left-0 tw-w-full md:tw-static ">
                    <button
                      id=""
                      className="_button_19rto_40 _purple_19rto_126 _filled_19rto_80 tw-font-medium tw-w-full tw-text-base"

                      disabled={!passwordRules.every(rule => rule.isValid)}
                      onClick={handleSubmit}
                    >
                     <div className="_btnFlex_1uoax_32"> {loading &&  (
                        <svg className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 00-8 8z" />
                        </svg>)}  Neues Passwort setzen</div>
                      
                      



                    </button>
                  </div>
                </form>
              </div>
            </div>
          </main>

        </div>
        <footer className="tw-flex tw-pb-6 tw-flex-col tw-items-center">

          <div className="tw-mt-6 tw-flex tw-items-center tw-gap-2 tw-text-gray-500 tw-mx-auto tw-text-xs">
            <p className="tw-my-0">Sie brauchen Hilfe?</p><a className="hover:tw-text-primary-500 hover:tw-underline"
              href="https://lumanote.de/contact" target="_blank" rel="noreferrer"><span
                className="tw-underline">Support kontaktieren</span><svg width="16" height="16" viewBox="0 0 16 16"
                  fill="none" xmlns="http://www.w3.org/2000/svg" className="tw-ml-[6px] tw-text-inherit">
                <path
                  d="M8.6624 7.83219C8.53573 7.83219 8.40906 7.78552 8.30906 7.68552C8.11573 7.49219 8.11573 7.17219 8.30906 6.97885L13.7757 1.51219C13.9691 1.31885 14.2891 1.31885 14.4824 1.51219C14.6757 1.70552 14.6757 2.02552 14.4824 2.21885L9.01573 7.68552C8.91573 7.78552 8.78906 7.83219 8.6624 7.83219Z"
                  fill="currentColor"></path>
                <path
                  d="M14.6688 5.03594C14.3954 5.03594 14.1687 4.80927 14.1687 4.53594V1.83594H11.4688C11.1954 1.83594 10.9688 1.60927 10.9688 1.33594C10.9688 1.0626 11.1954 0.835938 11.4688 0.835938H14.6688C14.9421 0.835938 15.1687 1.0626 15.1687 1.33594V4.53594C15.1687 4.80927 14.9421 5.03594 14.6688 5.03594Z"
                  fill="currentColor"></path>
                <path
                  d="M10.0026 15.1693H6.0026C2.3826 15.1693 0.835938 13.6226 0.835938 10.0026V6.0026C0.835938 2.3826 2.3826 0.835938 6.0026 0.835938H7.33594C7.60927 0.835938 7.83594 1.0626 7.83594 1.33594C7.83594 1.60927 7.60927 1.83594 7.33594 1.83594H6.0026C2.92927 1.83594 1.83594 2.92927 1.83594 6.0026V10.0026C1.83594 13.0759 2.92927 14.1693 6.0026 14.1693H10.0026C13.0759 14.1693 14.1693 13.0759 14.1693 10.0026V8.66927C14.1693 8.39594 14.3959 8.16927 14.6693 8.16927C14.9426 8.16927 15.1693 8.39594 15.1693 8.66927V10.0026C15.1693 13.6226 13.6226 15.1693 10.0026 15.1693Z"
                  fill="currentColor"></path>
              </svg></a>
          </div>
        </footer>
      </div>
    </div >



  );
};

export default ResetPassword;
